module.exports = __webpack_public_path__ + "43ec0dcbe5a156bf9e650bb8c15e7af6.png";